import AxiosClient from "../../../services/axios.services";

class BudgetControlActionsServices {
  getCompaniesBudget = (filters = {}) =>
    AxiosClient.get("/api/app/capacitacion_organizaciones_presupuesto/", {
      headers: { "Content-Type": "application/json" },
      params: filters,
    });

  createCompanyBudget = (data) =>
    AxiosClient.post(
      "/api/app/capacitacion_crear_organizacion_presupuesto/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteCompanyBudget = (id) =>
    AxiosClient.delete(
      `/api/app/capacitacion_eliminar_organizacion_presupuesto/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  createAnnualBudget = (data) =>
    AxiosClient.post(
      "/api/app/capacitacion_organizacion_nuevo_presupuesto_anual/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  getAnnualBudget = (params) =>
    AxiosClient.get("/api/app/capacitacion_organizacion_presupuesto_anual/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  updateMonthlyBudgetExpenditure = (data, id) =>
    AxiosClient.patch(
      `/api/app/capacitacion_organizacion_presupuesto_anual_mes_gastado/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  emailSend = (data) =>
    AxiosClient.post(
      `/api/app/capacitacion_organizacion_presupuesto_anual_correo/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new BudgetControlActionsServices();
